import {Skeleton, cn} from '@chekinapp/ui';
import {COUNTER_ROW_CLASS} from './constants';

type Props = {
  rows?: number;
};

function SettingsFormSkeleton({rows = 2}: Props) {
  return (
    <div className="flex w-full flex-col gap-2.5" aria-hidden="true">
      {Array.from({length: rows}, (_, index) => (
        <div
          key={index}
          className={cn(COUNTER_ROW_CLASS, 'flex w-full items-center gap-3.5')}
        >
          <Skeleton className="h-4 flex-1 rounded-md" />
          <Skeleton className="size-8 shrink-0 rounded-[10px]" />
          <Skeleton className="size-8 shrink-0 rounded-[10px]" />
        </div>
      ))}
      <Skeleton className="mt-3.5 h-12 w-full rounded-[var(--button-radius)]" />
    </div>
  );
}

export {SettingsFormSkeleton};
